import script from "./PmMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./PmMenu.vue?vue&type=script&setup=true&lang=js"

import "./PmMenu.vue?vue&type=style&index=0&id=f54d7432&lang=scss"

const __exports__ = script;

export default __exports__